var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`c-cui-card ${_vm.className}`},[_c('div',{on:{"click":_vm.toggleCollapse}},[_vm._t("header")],2),(!_vm.isCollapsed)?[_vm._t("content"),_vm._t("footer")]:_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }